export default {
  default (h, conf, slot, data) {
    let value = data?.[conf.__config__.renderKey] || conf.__config__.defaultValue;
    return <span tooltip={value} style={{position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}} >
      {value}
    </span>;
  },
};
